import {HttpClient} from '@angular/common/http';
import {select, Store} from '@ngrx/store';
import {ContextData} from '../../../common/context-data';
import {Observable} from 'rxjs';
import {TaxEstimation} from '@sportngin/se-commerce-sdk';
import {filter, map} from 'rxjs/operators';
import {Cart, ClareApiResponse} from '@sportngin/se-commerce-sdk/models/clare';
import {environment} from '../../../../environments/environment';
import {Injectable, Signal} from '@angular/core';
import {ApiRequestOptions, CommerceApiService} from './commerce-api.service';
import {toSignal} from '@angular/core/rxjs-interop';
import * as contextSelectors from '../../../common/context-data/context-data.selectors';

@Injectable({
  providedIn: 'root',
})
export class CartApiService extends CommerceApiService {
  readonly controllerPath: string = 'v3/commerce/shopper/v2/cart';

  protected contextData: Signal<ContextData>;

  constructor(
    protected http: HttpClient,
    protected store: Store,
  ) {
    super(http, store);

    this.contextData = toSignal(
      this.store.pipe(
        select(contextSelectors.selectContextData),
        filter(cd => !!cd),
      ),
    ) as Signal<ContextData>;
  }

  get guestKey(): string {
    return this.contextData().guestKey;
  }

  getTaxEstimate(): Observable<TaxEstimation> {
    const url = this.getUrl('/tax');
    return this.POST<TaxEstimation>(
      url,
      {
        guestKey: this.contextData().guestKey,
      },
      this.getOptions(),
    );
  }

  initializeClareCart(): Observable<Cart> {
    const url = `${environment.clareApiUrl}/cart`;
    return this.GET<ClareApiResponse<Cart>>(url, this.getOptions()).pipe(
      map(response => response.result),
    );
  }

  emptyCart(): Observable<void> {
    const url = this.getUrl('/empty');
    return this.POST<void>(url, {guestKey: this.guestKey}, this.getOptions());
  }

  getUrl(path = ''): string {
    path = `${this.controllerPath}${path}`;
    return super.getUrl(path);
  }

  protected override getOptions(
    src?: Partial<ApiRequestOptions>,
  ): ApiRequestOptions {
    const options: ApiRequestOptions = {
      params: {guestKey: this.guestKey},
      ...src,
    };

    if (!this.seApiToken()) {
      options.withCredentials = true;
    }

    return super.getOptions(options);
  }
}
